import { AccountType, type AccountsCopy } from '../../core'

export const getChartLabels = (
  accountType: AccountType,
  copy: AccountsCopy,
): { title: string; description: string } => {
  const hasPayments = [AccountType.LOAN, AccountType.MORTGAGE, AccountType.PROPERTY].includes(
    accountType,
  )

  const hasPaymentsAndSpend = [
    AccountType.CREDIT_CARD,
    AccountType.LINE_OF_CREDIT,
    AccountType.PREPAID,
    AccountType.CHECKING_LINE_OF_CREDIT,
  ].includes(accountType)

  if (hasPayments) return { title: copy.label_payments, description: copy.chart_title_payments }
  if (hasPaymentsAndSpend)
    return { title: copy.label_payments_spend, description: copy.chart_title_payments_spend }
  return { title: copy.label_income_spend, description: copy.chart_title_income_spend }
}
